import { render, staticRenderFns } from "./ClienteLemitExtraBlock.vue?vue&type=template&id=97570504&scoped=true"
import script from "./ClienteLemitExtraBlock.vue?vue&type=script&lang=js"
export * from "./ClienteLemitExtraBlock.vue?vue&type=script&lang=js"
import style0 from "./ClienteLemitExtraBlock.vue?vue&type=style&index=0&id=97570504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97570504",
  null
  
)

export default component.exports